import { getLocale } from './i18n';

export default {
    install: (app, options) => {
        app.config.globalProperties.$locale = getLocale();
    },
};
